// @ts-nocheck
import _ from 'lodash';
import PropTypes from 'prop-types';
import { makeStyles, Box, Typography } from '@material-ui/core';
import { StringUtils } from '../utils';
import Section from './Section';

const useStyles = makeStyles(theme => ({
  listContainer: {
    height: '100%',
    overflow: 'auto',
  },
  listContent: {
    maxHeight: '468px',
    paddingRight: theme.spacing(3),
  },
  listItem: {
    borderBottom: `1px dashed ${theme.palette.divider}`,
    marginBottom: theme.spacing(3),
    '&:last-child': {
      marginBottom: '0',
    },
  },
  itemContent: {
    marginBottom: theme.spacing(2),
  },
}));

function ListSection(props) {
  const classes = useStyles();

  const { id, title, className, data, emptyContent } = props;

  return (
    <Section id={id} className={className} title={title}>
      <Box className={classes.listContainer}>
        {!_.isEmpty(data) ? (
          <Box className={classes.listContent}>
            {data.map((item, index) => (
              <Box
                id={StringUtils.makeId(id, `item-${index}`)}
                key={item.id}
                className={classes.listItem}
              >
                <Typography
                  id={StringUtils.makeId(id, `item-${index}-title`)}
                  variant="caption"
                  component="p"
                >
                  {item.title}
                </Typography>
                <Typography
                  id={StringUtils.makeId(id, `item-${index}-subtitle`)}
                  variant="caption"
                  component="p"
                >
                  {item.subtitle}
                </Typography>
                <Box
                  id={StringUtils.makeId(id, `item-${index}-content`)}
                  className={classes.itemContent}
                >
                  {item.content}
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <>{emptyContent}</>
        )}
      </Box>
    </Section>
  );
}

ListSection.defaultProps = {
  id: undefined,
  className: undefined,
  emptyContent: undefined,
};

ListSection.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
    })
  ).isRequired,
  emptyContent: PropTypes.node,
};

export default ListSection;
